/** Tri-state métier pour l'affectation produit ↔ poste KDS. */
export const ASSIGN_NO_PREP = '__NO_PREP__';
export const ASSIGN_PREP_NO_STATION = '__PREP_NO_STATION__';

export const PREP_KIND_OPTIONS = [
  {
    value: 'KITCHEN',
    label: 'Cuisine',
    hint: 'Plats chauds et préparations cuisine — utilisé par l’écran KDS pour regrouper les tickets.',
  },
  {
    value: 'BAR',
    label: 'Bar',
    hint: 'Boissons et envois bar — le type technique oriente l’affichage KDS, pas le nom affiché.',
  },
  {
    value: 'DESSERT',
    label: 'Desserts',
    hint: 'Pâtisserie / desserts — type technique KDS, le nom du poste reste libre.',
  },
  {
    value: 'OTHER',
    label: 'Autre catégorie',
    hint: 'Poste personnalisé (sushi, grillades, etc.) — type générique pour le KDS.',
  },
];

/** Code technique stable à partir du nom affiché (nouveau poste uniquement). */
export function suggestStationCodeFromLabel(label, existingCodes = []) {
  let base = String(label || '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .toUpperCase()
    .slice(0, 28);
  if (!base) base = 'POSTE';
  const used = new Set(existingCodes.map((c) => String(c || '').toUpperCase()));
  let code = base;
  let n = 2;
  while (used.has(code)) {
    code = `${base}_${n}`;
    n += 1;
  }
  return code;
}

export function assignSelectValue(product) {
  if (product?.preparationStationId) return product.preparationStationId;
  if (product?.requiresPreparation) return ASSIGN_PREP_NO_STATION;
  return ASSIGN_NO_PREP;
}

export function parseAssignRawValue(rawValue) {
  if (rawValue === ASSIGN_NO_PREP) {
    return { preparationStationId: null, requiresPreparation: false };
  }
  if (rawValue === ASSIGN_PREP_NO_STATION) {
    return { preparationStationId: null, requiresPreparation: true };
  }
  return { preparationStationId: rawValue, requiresPreparation: true };
}

export function mergeProductRow(prev, updated) {
  if (!updated?.id) return prev;
  return { ...prev, ...updated };
}

export function computePrepSummary(products, stations) {
  let onStation = 0;
  let noPrep = 0;
  let prepNoStation = 0;
  const perStation = {};
  for (const s of stations) {
    perStation[s.id] = 0;
  }
  for (const p of products) {
    if (p.preparationStationId) {
      onStation += 1;
      if (perStation[p.preparationStationId] != null) {
        perStation[p.preparationStationId] += 1;
      }
    } else if (p.requiresPreparation) prepNoStation += 1;
    else noPrep += 1;
  }
  const inactiveReferenced = stations.filter(
    (s) => s.actif === false && (perStation[s.id] || 0) > 0
  );
  const inactiveById = new Map(stations.map((s) => [s.id, s]));
  let inactiveStationProducts = 0;
  for (const p of products) {
    if (!p.preparationStationId) continue;
    const st = inactiveById.get(p.preparationStationId);
    if (st?.actif === false) inactiveStationProducts += 1;
  }
  return {
    total: products.length,
    onStation,
    noPrep,
    prepNoStation,
    perStation,
    inactiveReferenced,
    inactiveStationProducts,
  };
}

export function productPrepStatusLabel(product, stationById) {
  if (!product?.requiresPreparation) return 'Sans préparation';
  if (product.preparationStationId) {
    const st = stationById.get(product.preparationStationId);
    return st ? `Poste : ${st.label}` : 'Poste inconnu';
  }
  return 'Préparation — poste à choisir';
}

export function sortProductsStable(list) {
  return [...list].sort((a, b) =>
    String(a.nom || '').localeCompare(String(b.nom || ''), 'fr', { sensitivity: 'base' })
  );
}
